import { Box, Button, Modal, Typography } from "@material-ui/core"
import { ModalStyles } from "../../styles";
import { Api } from "../../lib/api";
import { useSnackbar } from "notistack";

type DeleteSourceModalProps = {
    open: boolean
    onClose: () => void
    userSlug: string
    websiteSlug: string
    onSourceDeleted: () => void
}

export const DeleteSourceModal = ({ open, onClose, userSlug, websiteSlug, onSourceDeleted }: DeleteSourceModalProps) => {
    const modalStyles = ModalStyles();

    const { enqueueSnackbar } = useSnackbar();

    return <Modal
        open={open}
        onClose={onClose}
    >
        <div className={modalStyles.paper}>
            <>
                <Box mb={2}>
                    <Typography variant="h4" component="h4">
                        Delete Source
                    </Typography>
                </Box>
                <Box mb={6}>
                    <Typography>
                        {`Please confirm you want to delete source ${websiteSlug} for user ${userSlug}!`}
                    </Typography>
                </Box>
                <Box mt={2}>
                    <Button variant="contained" onClick={onClose} style={{ marginRight: 20 }} >Cancel</Button>
                    <Button variant="contained" color="secondary" onClick={async () => {
                        try {
                            await Api.deleteSource(userSlug, websiteSlug);
                            enqueueSnackbar(`Source ${websiteSlug} deleted!`, { variant: "success" });
                            onSourceDeleted();
                        } catch (error: any) {
                            enqueueSnackbar(error.response.data.message, { variant: "error" });
                        }
                        onClose();
                    }}>Delete</Button>
                </Box>
            </>
        </div>
    </Modal>
}